<pf-dropdown #userDropdown [hideArrow]="false" class="user-menu">
  <!-- Dropdown Head -->
  <div slot="head">
    <a class="nav-link usrDropLink">
      <pf-image [src]="userData?.picture" fallbackSrc="assets/img/default-profile.png" class="user-image-small"
        width="30" height="30" alt="User Image" rounded="true" />
      <span>{{userData?.email}}<i class="topDrop fas fa-angle-down"></i></span>
    </a>
  </div>
  <!-- Dropdown Body -->
  <div slot="body">
    <li class="user-header">
      <a (click)="openChangePasswordModal()" class="cursor-pointer">
        <i class="fas fa-key"></i>
        Forgot Password
      </a>
    </li>
    <li class="user-header">
      <a (click)="logout()" class="cursor-pointer">
        <i class="fas fa-sign-out-alt"></i>
        Sign out
      </a>
    </li>
  </div>
</pf-dropdown>

<!-- Modal Backdrop -->
<div class="modal-backdrop" [class.show]="isModalOpen"></div>

<!-- ... existing HTML for the user profile, etc. ... -->

<!-- Change Password Modal -->
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display': isModalOpen ? 'block' : 'none'}">
  <div class="modal-dialog" role="document">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title">Forgot Password</h5>
        <button type="button" class="close" aria-label="Close" (click)="closeChangePasswordModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmitForgotPassword()">

          <!-- Step 1: Email -->
          <div class="mb-3" *ngIf="!showResetForm">
            <input formControlName="email" type="email" class="form-control" placeholder="Enter your email" />
            <div *ngIf="forgotPasswordForm.get('email')?.touched" class="text-danger small">
              <div *ngIf="forgotPasswordForm.get('email')?.hasError('required')">Email is required.</div>
              <div *ngIf="forgotPasswordForm.get('email')?.hasError('email')">Enter a valid email.</div>
            </div>
          </div>

          <div class="col-12 mb-3" *ngIf="!showResetForm">
            <button type="submit" class="btn btn-primary d-block w-100" [disabled]="forgotPasswordForm.invalid">
              Send OTP
            </button>
          </div>
        </form>

        <!-- Step 2: Reset Password -->
        <form *ngIf="showResetForm" [formGroup]="resetPasswordForm" (ngSubmit)="onSubmitResetPassword()">

          <div class="mb-3">
            <input formControlName="email" type="email" class="form-control" readonly />
          </div>

          <div class="mb-3">
            <input formControlName="code" type="text" class="form-control" placeholder="Enter OTP Code" />
            <div *ngIf="resetPasswordForm.get('code')?.touched && resetPasswordForm.get('code')?.hasError('required')" class="text-danger small">
              OTP Code is required.
            </div>
          </div>

          <!-- New Password -->
          <div class="mb-3">
            <input formControlName="new_password" type="password" class="form-control" placeholder="New Password" />
            <div *ngIf="resetPasswordForm.get('new_password')?.touched" class="text-danger small">
              <div *ngIf="resetPasswordForm.get('new_password')?.hasError('required')">Password is required.</div>
              <div *ngIf="resetPasswordForm.get('new_password')?.hasError('minlength')">Min 8 characters required.</div>
              <div *ngIf="resetPasswordForm.get('new_password')?.hasError('pattern')">
                Password must contain at least:
                <ul class="mb-0">
                  <li>One uppercase letter</li>
                  <li>One lowercase letter</li>
                  <li>One number</li>
                  <li>One special character</li>
                </ul>
              </div>
            </div>
          </div>

          <!-- Confirm Password -->
          <div class="mb-3">
            <input formControlName="confirm_password" type="password" class="form-control" placeholder="Confirm Password" />
            <div *ngIf="resetPasswordForm.hasError('passwordMismatch') && resetPasswordForm.get('confirm_password')?.touched" class="text-danger small">
              Passwords do not match.
            </div>
          </div>

          <div class="col-12 mb-3">
            <button type="submit" class="btn btn-success d-block w-100" [disabled]="resetPasswordForm.invalid">
              Reset Password
            </button>
          </div>
        </form>
      </div>

    </div>
  </div>
</div>
